import React, { useContext, useEffect, useState } from 'react'

//interfaces
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';
import { AllUsersSortByType, ResourcePermission } from  '@/interfaces/orgSettings';
import { SortBy } from  '@/interfaces/toggle';

//hooks and helpers
import { getStatus, hasEditorPermissions, isExternallyManaged} from  '@/helpers/OrgSettings';

//components
import RoleDropdown from  '@/components/elements/global/dropdown/RoleDropdown';
import GroupIconsAndName from  '@/components/elements/orgSettings/tableCellItems/GroupIconsAndName';

//context
import { OrgSettingsUserGroupsContext } from '@/context/OrgSettingsUserGroupsContext';

export const allUserGroupsConstants = {
    headerText: "All User Groups",
    addUserButtonText: "Add New User Group",
    addUserButtonLabel: "Add new user group to your organisation",
    filterLabel: "click to view filter options",
    searchLabel: "Filter user groups with search input",
    filterPanelHeader: "Include",
    filterArchiveLabel: "Archived Groups",
    noDataMessage: "No user group data found."

}



const UseAllUserGroupsScreen = () => {  
    const {getUserGroups, sortToggle, setUserGroupPermission, userGroupData, paginationSettings, setSortToggle, includeArchivedUserGroups, setIncludeArchivedUserGroups, setSearchString, searchString, notificationDetails, isLoading, setIsLoading} = useContext(OrgSettingsUserGroupsContext);
    
    const [tableContent, setTableContent] = useState<ITableContent>();
    const [showFilterPanel, setShowFilterPanel] = useState<boolean>(false);
    const [showSimpleTable, setShowSimpleTable] = useState<boolean>(false);


    const filterText = includeArchivedUserGroups ? "Filter (1)" : "Filter";

    
    const columns: Array<ITableColumn | boolean> = [
        { title: "Groups", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.GROUPS, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.GROUPS, SortBy.ASCENDING) }, 
        { title: "Workspaces", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.WORKSPACES, SortBy.ASCENDING),  onSortDescendingClick: () => toggleSort(AllUsersSortByType.WORKSPACES,  SortBy.DESCENDING)}, 
        { title: "Members", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.MEMBERS, SortBy.ASCENDING),  onSortDescendingClick: () => toggleSort(AllUsersSortByType.MEMBERS,  SortBy.DESCENDING)}, 
        { title: "Org Role", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.PERMISSIONS, SortBy.ASCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.PERMISSIONS,  SortBy.DESCENDING) }, 
        includeArchivedUserGroups && { title: "Status", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.STATUS, SortBy.ASCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.STATUS, SortBy.DESCENDING) }
    ];

    useEffect(()=> {
        setIsLoading(true);
        getUserGroups();
    }, [searchString, sortToggle, includeArchivedUserGroups]);
  
    useEffect(() => {
        if (userGroupData === undefined) {
            setIsLoading(true);
            setTableContent({rows: [], columns: columns as ITableColumn[]});
            setShowSimpleTable(true);
            return;
        }
    
        let rows: ITableRows[] = [];
        userGroupData?.forEach((userGroup) => {
            const row: ITableRows = {
                content: [
                    <GroupIconsAndName
                        key={`${userGroup.id}-gian`}
                        profilePictures={userGroup.profilePictureUrls}
                        userGroupId={userGroup.id}
                        userGroupName={userGroup.name}
                        truncate={50}
                        hasNoMembers={userGroup.totalMembers === 0}
                        isManagedGroup={isExternallyManaged(userGroup.groupManagementType)}
                        externalLoginIcon={userGroup.provider?.iconUrl}
                    />,
                    userGroup.totalWorkspaces,
                    userGroup.totalMembers,
                    <RoleDropdown key={`${userGroup.id}-rdd`} id={userGroup.id} setPermission={setUserGroupOrgPermission} buttonContent={hasEditorPermissions(userGroup?.permission) ? 'Admin' : 'Member'} buttonAriaLabel="Open dropdown selection to set the user group's permission within the organisation" dropdownItems={[{ header: "Admin", content: "An admin has full control across all workspaces.", isSelected: hasEditorPermissions(userGroup?.permission) }, { header: "Member", content: "A member of an organisation that can be assigned as a viewer or editor of certain workspaces or content areas.", isSelected: !hasEditorPermissions(userGroup?.permission)}]} />, 
                    includeArchivedUserGroups && getStatus(userGroup?.status)
                ], 
                isHighlightedRow:isExternallyManaged(userGroup.groupManagementType),
                controls: [
                    {content:"Edit Group", onClick:() => onEditClick(userGroup.id)}, 
                ]
            };
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns as ITableColumn[]});
        setShowSimpleTable(true);
        setIsLoading(false);
    }, [userGroupData])

    function toggleSort(sortByType: AllUsersSortByType, sortBy: SortBy) {
        setSortToggle([sortByType, sortBy]);
    }

    function onIncludeArchivedUserGroupsClick(){ 
        setIncludeArchivedUserGroups(!includeArchivedUserGroups);
    }

    function onEditClick(userGroupId:any) {
        window.location.replace(`/admin/OrganizationUserGroup/UserGroupDetail/${userGroupId}`);
    }

    function onAddNewUserGroupClick() {
        window.location.replace(`/admin/OrganizationUserGroup/Create`);
    }

    function setUserGroupOrgPermission(userGroupId: number, setRoleAsAdmin: boolean) {
        setUserGroupPermission(userGroupId, setRoleAsAdmin ? ResourcePermission.MANAGE : ResourcePermission.READ)
    }

    function setPage(page: number) {
        getUserGroups(page);
    }

    return{ filterText, setSearchString, searchString, showSimpleTable, tableContent, setPage, onAddNewUserGroupClick, includeArchivedUserGroups, onIncludeArchivedUserGroupsClick, setShowFilterPanel, showFilterPanel, paginationSettings, setIncludeArchivedUserGroups, notificationDetails, isLoading}
}

export default UseAllUserGroupsScreen